import * as React from "react";
import type { SVGProps } from "react";
const SvgIconVolumeUp = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    role="img"
    focusable="false"
    width="100%"
    height="100%"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.9 2.4q-.57.04-1.1.36c-.05.03-1.32 1.21-2.8 2.62L5.3 7.95H4.23c-.59 0-1.15 0-1.26.02-1.11.14-1.98.97-2.15 2.06-.05.26-.05 3.62-.01 3.9.15 1 .86 1.78 1.84 2.05.23.06.24.06 1.44.08l1.2.01 2.59 2.52c1.42 1.39 2.63 2.56 2.7 2.6.23.17.61.33.93.39.2.04.64.04.84 0 .9-.16 1.68-.81 1.97-1.65.13-.39.12.05.11-8.07v-7.5l-.06-.2c-.3-1.02-1.16-1.71-2.2-1.76zm-.06 1.75c-.1.04-.9.8-5.47 5.14-.21.2-.33.28-.5.34-.05.02-.57.03-1.45.04l-1.38.02-.1.05c-.15.08-.3.23-.36.37l-.06.13v3.53l.06.12q.12.25.38.38l.12.06h1.26c.75 0 1.33.01 1.42.02.25.05.36.12.8.54 2.26 2.22 5.05 4.92 5.1 4.95q.09.04.28.04c.16 0 .22 0 .34-.06q.27-.13.4-.4l.05-.11v-7.32c0-6.12 0-7.34-.03-7.43-.1-.34-.54-.55-.86-.4m8.64 1.46c-.35.12-.58.45-.58.82 0 .19.02.27.2.57q.83 1.49 1.15 2.99c.3 1.41.3 2.61 0 4.03q-.32 1.48-1.16 2.99c-.18.31-.2.4-.19.62.04.54.56.91 1.07.77.17-.05.35-.16.43-.27.15-.19.46-.76.69-1.24.72-1.55 1.1-3.24 1.1-4.89 0-1.72-.42-3.48-1.2-5.1-.2-.38-.48-.89-.58-1.02-.2-.25-.62-.37-.93-.27M17.31 8.8c-.23.07-.45.28-.53.5-.05.12-.05.18-.05.36.02.25.03.29.26.6.35.5.5.93.52 1.57.04.78-.12 1.36-.52 1.91-.23.32-.24.35-.26.6 0 .28.05.44.22.62q.22.25.55.28c.35.02.59-.1.84-.44.42-.57.68-1.15.82-1.84.05-.25.05-.34.05-.96s0-.7-.05-.96q-.21-1.04-.84-1.87-.31-.42-.76-.4c-.08 0-.2 0-.25.03"
      fill="currentColor"
    />
  </svg>
);
export default SvgIconVolumeUp;
